<template>
  <div
    class="d-flex flex-column align-center justify-center"
  >
    <v-form
      v-if="!isSuccess"
      ref="form"
    >
      <div
        class="d-flex flex-column ga-3 pa-7 mt-5 mb-5"
        style="border-radius: 6px; border: 1px solid #ccc; max-width: 1000px; width: 1000px"
      >
        <div class="d-flex align-center justify-space-between">
          <img
            src="@/assets/AWD_logo_horizontal_RGB.png"
            style="max-width: 300px;"
          >
          <div class="d-flex flex-column">
            <span>Tel: 905-850-7541</span>
            <span>Fax: 905-850-6090</span>
            <span>Web: <a href="https://www.aluminumwindowdesigns.com">aluminumwindowdesigns.com</a></span>
            <span>440 Hanlan Road, Woodbridge, ON, L4L 3P6</span>
          </div>
        </div>
        <!-- <v-tabs
          v-model="selectedTab"
        >
          <v-tab>
            SERVICE FORM
          </v-tab>
          <v-tab>
            WATER TEST FORM
          </v-tab>
        </v-tabs> -->
        <div
          v-if="selectedTab === null"
          class="d-flex ga-3 pt-16"
        >
          <div
            class="pa-10 text-center"
            style="border: 1px solid #3F76D4; border-radius: 10px; width: 100%; cursor: pointer;"
            @click="selectedTab = 0"
          >
            <h1 style="color: #3F76D4">
              SERVICE FORM
            </h1>
          </div>
          <div
            class="pa-10 text-center"
            style="border: 1px solid #3F76D4; border-radius: 10px; width: 100%; cursor: pointer;"
            @click="selectedTab = 1"
          >
            <h1 style="color: #3F76D4">
              WATER TEST FORM
            </h1>
          </div>
        </div>
        <div
          v-if="selectedTab !== null"
          style="cursor: pointer;"
        >
          <v-icon
            style="color: #000;"
            @click="cancel()"
          >
            mdi-arrow-left
          </v-icon>
        </div>
        <div v-if="selectedTab === 0">
          <h1>Service Request Form</h1>
          <span>Complete this form to request service from the AWD service department. This will generate a work order for your request.</span>
        </div>
        <div v-else-if="selectedTab === 1">
          <h1>Water Test Request Form</h1>
          <span>Complete this form to request a water test from the AWD service department. This will generate a work order for your request.</span>
        </div>
        <div v-if="selectedTab !== null">
          <h2>Personal Information</h2>
          <div>
            <div class="outer-div">
              <div class="inner-div">
                <span class="title-span">Contact Name<RedAsterisk /></span>
                <v-text-field
                  v-model="form.contact_name"
                  placeholder="Enter Contact Name"
                  :rules="[(v) => !!v || 'Contact Name is required']"
                  outlined
                />
              </div>
            </div>
            <div class="outer-div">
              <div class="inner-div">
                <span class="title-span">Contact Email<RedAsterisk /></span>
                <v-text-field
                  v-model="form.contact_email"
                  placeholder="Enter Contact Email"
                  :rules="[
                    (v) => !!v || 'Contact Email is required',
                    (v) =>
                      !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Invalid email format'
                  ]"
                  outlined
                />
              </div>
              <div class="inner-div">
                <span class="title-span">Contact Phone Number<RedAsterisk /></span>
                <v-text-field
                  v-model="form.contact_phone"
                  placeholder="Enter Contact Phone Number"
                  :rules="[
                    (v) => !!v || 'Contact Phone Number is required',
                    (v) =>
                      !v || /^\+?[\d\s\-()]{7,20}$/.test(v) || 'Invalid phone number format'
                  ]"
                  outlined
                />
              </div>
            </div>
            <v-divider />
            <h2 class="mt-4 mb-3">
              Detailed Site Description
            </h2>
            <div class="outer-div">
              <!-- <div class="inner-div">
              <span class="title-span">Project Name</span>
              <v-select
                v-model="form.project_id"
                :items="projects"
                item-text="name"
                item-value="id"
                outlined
                clearable
                placeholder="Select Project (optional)"
              />
            </div> -->
              <div class="inner-div">
                <span class="title-span">Site Address<RedAsterisk /></span>
                <!-- <v-text-field
                v-model="form.address"
                placeholder="Enter site address"
                :rules="[(v) => !!v || 'Address is required']"
                outlined
              /> -->
                <vuetify-google-autocomplete
                  id="google"
                  ref="google"
                  v-model="form.address"
                  :rules="[(v) => !!v || 'Site Address is required']"
                  classname="form-control"
                  :country="'ca'"
                  outlined
                  placeholder="Enter Site Address"
                  @placechanged="getAddressData"
                />
              </div>
              <div class="inner-div">
                <span class="title-span">Site Nickname / Tower</span>
                <v-text-field
                  v-model="form.tower"
                  placeholder="Enter Tower"
                  outlined
                />
              </div>
            </div>
            <div class="d-flex flex-column ga-1">
              <div
                v-for="sectionItem, index in form.sectors"
                :key="index"
                class="outer-div"
              >
                <div
                  class="inner-div"
                >
                  <span class="title-span">Floor<RedAsterisk /></span>
                  <v-text-field
                    v-model="sectionItem.floor"
                    placeholder="Enter Floor"
                    :rules="[(v) => !!v || 'Floor is required']"
                    outlined
                  />
                </div>

                <div class="inner-div">
                  <span class="title-span">Unit<RedAsterisk /></span>
                  <v-text-field
                    v-model="sectionItem.unit"
                    placeholder="Enter Unit"
                    :rules="[(v) => !!v || 'Unit is required']"
                    outlined
                  />
                </div>

                <div class="inner-div">
                  <span class="title-span">Sector / Area<RedAsterisk /></span>
                  <v-text-field
                    v-model="sectionItem.location"
                    placeholder="Enter Location (within unit)"
                    :rules="[(v) => !!v || 'Location is required']"
                    outlined
                  />
                </div>

                <div
                  class="inner-div"
                  style="min-width: 350px;"
                >
                  <span class="title-span">Description<RedAsterisk /></span>
                  <v-text-field
                    v-model="sectionItem.description"
                    placeholder="Enter Description"
                    :rules="[(v) => !!v || 'Description is required']"
                    outlined
                  />
                </div>

                <div class="pt-10">
                  <v-btn
                    color="error"
                    small
                    icon
                    @click="form.sectors.splice(index, 1)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </div>
              <!-- <div class="inner-div">
                <span class="title-span">Tower / Phase</span>
                <v-text-field
                  v-model="form.tower"
                  placeholder="Enter Tower (optional)"
                  counter="15"
                  outlined
                />
              </div>
              <div class="inner-div">
                <span class="title-span">Floor(s) / Reference<RedAsterisk /></span>
                <v-text-field
                  v-model="form.floor"
                  placeholder="e.g., 4-7"
                  :rules="[(v) => !!v || 'Floor(s) is required', (v) => !!v && v.length <= 15 || 'Max 15 characters']"
                  counter="15"
                  outlined
                />
              </div>
              <div class="inner-div">
                <span class="title-span">Unit Number(s)<RedAsterisk /></span>
                <v-text-field
                  v-model="form.unit"
                  placeholder="e.g., 405, 406, 500, 510, 612, 713"
                  :rules="[(v) => !!v || 'Unit Number(s) is required', (v) => !!v && v.length <= 15 || 'Max 15 characters']"
                  counter="15"
                  outlined
                />
              </div> -->
            </div>
            <div class="pb-6">
              <v-btn
                color="primary"
                outlined
                @click="form.sectors.push({floor: null, unit: null, location: null, description: null })"
              >
                Add Section
              </v-btn>
            </div>
            <v-divider />
            <div
              v-if="selectedTab === 0"
              class=""
            >
              <div class="inner-div pt-5">
                <span class="title-span">Subject<RedAsterisk /></span>
                <v-text-field
                  v-model="form.job_description"
                  placeholder="Enter Subject"
                  :rules="[(v) => !!v || 'Subject is required', (v) => !!v && v.length <= 100 || 'Max 100 characters']"
                  counter="100"
                  outlined
                />
              </div>
              <div class="inner-div">
                <span class="title-span">Issue Category<RedAsterisk /></span>
                <v-select
                  v-model="form.category_ids"
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  outlined
                  clearable
                  :rules="[(v) => !!v || 'Issue Category is required']"
                  placeholder="Select Issue Category"
                >
                  <template #item="{ item }">
                    <v-chip
                      class="mt-1 mb-1"
                      small
                      text-color="white"
                      style="cursor: pointer; text-transform: uppercase"
                      :color="item ? item.color : 'white'"
                    >
                      {{ item ? item.name : '' }}
                    </v-chip>
                  </template>
                  <!-- eslint-disable-next-line vue/no-template-shadow -->
                  <template #selection="{ item }">
                    <v-chip
                      class="mt-1 mb-1"
                      small
                      text-color="white"
                      style="cursor: pointer; text-transform: uppercase"
                      :color="item ? item.color : 'white'"
                    >
                      {{ item ? item.name : '' }}
                    </v-chip>
                  </template>
                </v-select>
              </div>
              <div
                class="inner-div"
              >
                <span class="title-span">Attachments (To add multiple attachments, please hold CTRL when selecting the files)</span>
                <v-file-input
                  v-model="attachments"
                  capture="user"
                  outlined
                  small-chips
                  multiple
                  placeholder="Click to upload files"
                />
              </div>
              <div class="inner-div">
                <span class="title-span">Extra Request</span>
                <v-textarea
                  v-model="form.description"
                  placeholder="Enter Extra Request"
                  counter="2000"
                  outlined
                />
              </div>
              <div
                class="inner-div"
              >
                <span>Preferred Dates (Please select a preferred range of dates for site visit)</span>
                <v-date-picker
                  v-model="form.preferred_dates"
                  multiple
                  :allowed-dates="allowedDates"
                  full-width
                  range
                />
              </div>
            </div>
            <div
              v-if="selectedTab === 1"
              class=""
            >
              <h2 class="mt-4">
                Pre-Test Readiness Checklist
              </h2>
              <span class="title-span">Please confirm the following have been completed prior to testing:</span>
              <div>
                <v-checkbox
                  v-model="form.is_caulking_completed"
                  label="Interior / Exterior Caulking Completed"
                  :rules="[(v) => !!v || 'Caulking must be completed before testing']"
                />
              </div>
              <span class="title-span">Exterior Finishes Completed</span>
              <v-input
                v-model="form.exterior_finish_ids"
                :rules="[(v) => v && v.length > 0 || 'At least one exterior finish must be selected']"
              >
                <template #default>
                  <div class="d-flex ga-3 mb-6">
                    <v-checkbox
                      v-for="(extFinish, index) in exteriorFinishes"
                      :key="index"
                      v-model="form.exterior_finish_ids"
                      :label="extFinish.name"
                      :value="extFinish.id"
                      hide-details
                    />
                  </div>
                </template>
              </v-input>
            </div>
            <v-divider v-if="selectedTab === 1" />
            <div
              v-if="selectedTab === 1"
              class="d-flex flex-column ga-2"
            >
              <h2 class="mt-4">
                Testing Specifications (ASTM E1105)
              </h2>
              <span class="title-span">Standard: ASTM E1105 - Standard Test Method for Field Determination of
                Water Penetration of Installed Exterior Windows, Skylights, Doors, and Curtain
                Walls, by Uniform or Cyclic Static Air Pressure Difference.
              </span>
              <span class="title-span">Test Purpose:
                To evaluate the resistance of installed fenestration systems to water penetration
                under controlled conditions using a calibrated spray system and pressure
                chamber.
              </span>
              <span class="title-span">Key Parameters (to be confirmed by project manager or testing agency):</span>
              <div>
                <span class="title-span">Static or Cyclic Pressure Testing: </span>
                <v-radio-group
                  v-model="form.pressure_testing_type_id"
                  :rules="[(v) => !!v || 'Pressure Testing Type is required']"
                >
                  <v-radio
                    label="Static Pressure"
                    value="1"
                  />
                  <v-radio
                    label="Cyclic Pressure"
                    value="2"
                  />
                </v-radio-group>
              </div>
              <span class="title-span">Specified Test Pressure:</span>
              <v-text-field
                v-model="form.test_pressure"
                placeholder="Enter Test Pressure (Pa)"
                :rules="[(v) => !!v || 'Test Pressure is required']"
                type="number"
                outlined
              />
              <span class="title-span">Spray Duration per Cycle (if cyclic):</span>
              <v-text-field
                v-model="form.spray_duration"
                placeholder="Enter Spray Duration (minutes)"
                :rules="[(v) => !!v || 'Spray Duration is required']"
                type="number"
                outlined
              />
              <span class="title-span">Total Duration of Test:</span>
              <v-text-field
                v-model="form.test_duration"
                placeholder="Enter Total Duration (minutes)"
                :rules="[(v) => !!v || 'Total Duration is required']"
                type="number"
                outlined
              />
              <span class="title-span">Nozzle Type / Flow Rate:</span>
              <v-text-field
                v-model="form.nozzle_type"
                placeholder="Enter Nozzle Type / Flow Rate (GPM)"
                :rules="[(v) => !!v || 'Nozzle Type / Flow Rate is required']"
                type="number"
                outlined
              />
              <span class="title-span">Ambient Weather Conditions (estimated):</span>
              <v-text-field
                v-model="form.weather_conditions"
                placeholder="Enter Ambient Weather Conditions"
                :rules="[(v) => !!v || 'Ambient Weather Conditions is required']"
                outlined
              />
              <span class="title-span">Select the samples that will be tested on-site:</span>
              <v-input
                v-model="form.sample_ids"
                :rules="[(v) => v && v.length > 0 || 'At least one sample must be selected']"
              >
                <template #default>
                  <div class="d-flex ga-3 mb-6">
                    <v-checkbox
                      v-for="(extFinish, index) in samples"
                      :key="index"
                      v-model="form.sample_ids"
                      :label="extFinish.name"
                      :value="extFinish.id"
                      hide-details
                    />
                  </div>
                </template>
              </v-input>
              <div
                class="inner-div"
              >
                <span class="title-span">Attachments (To add multiple attachments, please hold CTRL when selecting the files)</span>
                <v-file-input
                  v-model="attachments"
                  capture="user"
                  outlined
                  small-chips
                  multiple
                  placeholder="Click to upload files"
                />
              </div>
              <div
                class="inner-div"
              >
                <span class="title-span">Date of Water Test</span>
                <v-menu
                  v-model="waterTestDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.water_test_date"
                      label="Click to select date of water test"
                      prepend-icon="mdi-calendar"
                      readonly
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      :rules="[(v) => !!v || 'Date of Water Test is required']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.water_test_date"
                    @input="waterTestDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </div>
              <div class="inner-div">
                <span class="title-span">Additional Notes / Special Instructions</span>
                <v-textarea
                  v-model="form.description"
                  placeholder="Enter Additional Notes / Special Instructions"
                  :rules="[(v) => !!v || 'Additional Notes / Special Instructions is required', (v) => !!v && v.length <= 2000 || 'Max 2000 characters']"
                  counter="2000"
                  outlined
                />
              </div>
            </div>
            <v-divider />
            <div class="d-flex ga-4 justify-end mt-4">
              <v-btn
                color="normal"
                @click="cancel()"
              >
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                @click="submit"
              >
                Submit Request
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </v-form>
    <div
      v-else
      class="d-flex flex-column ga-3 pa-7 mt-5 mb-5"
      style="border-radius: 6px; border: 1px solid #ccc; min-width: 800px; max-width: 1000px;"
    >
      <div class="d-flex align-center justify-space-between">
        <img
          src="@/assets/AWD_logo_horizontal_RGB.png"
          style="max-width: 300px;"
        >
        <div class="d-flex flex-column">
          <span>Tel: 905-850-7541</span>
          <span>Fax: 905-850-6090</span>
          <span>Web: <a href="https://www.aluminumwindowdesigns.com">aluminumwindowdesigns.com</a></span>
          <span>440 Hanlan Road, Woodbridge, ON, L4L 3P6</span>
        </div>
      </div>
      <div
        class="d-flex flex-column align-center justify-center pa-5 ga-3"
      >
        <span class="f2 fw600">Thank you</span>
        <span
          class="f7 text-center"
          style="color: gray"
        >
          Your {{ selectedTab === 0 ? 'service' : 'water test' }} request has been submitted successfully.
        </span>
        <div
          class="d-flex flex-column ga-2 pa-7 text-center mt-3"
          style="background-color: #F8FAFC; border-radius: 10px;"
        >
          <span class="fw600 f7">Request Reference</span>
          <span class="f8 text-center">
            Your request ID is <strong>{{ form.id ? form.id : '' }}</strong>, which you can use for future reference.
          </span>
        </div>
        <div class="d-flex align-center ga-2">
          <v-icon style="font-size: 28px;">
            mdi-email-outline
          </v-icon>
          <span class="f8 text-center">A confirmation email has been sent to you.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

export default {
  components: {
    VuetifyGoogleAutocomplete,
  },
  props: {

  },
  data: () => ({
    form: null,
    defaultForm: {
      project_id: null,
      address: null,
      contact_name: null,
      contact_phone: null,
      contact_email: null,
      job_description: null,
      tower: null,
      floor: null,
      unit: null,
      category_ids: null,
      description: null,
      exterior_finish_ids: [],
      is_caulking_completed: 0,
      pressure_testing_type_id: null,
      test_pressure: null,
      spray_duration: null,
      test_duration: null,
      nozzle_type: null,
      weather_conditions: null,
      water_test_date: null,
      sample_ids: [],
      preferred_dates: [],
      sectors: [{
        floor: null, unit: null, location: null, description: null,
      }],
    },
    categories: [],
    projects: [],
    attachments: [],
    exteriorFinishes: [],
    pressureTestingTypes: [],
    samples: [],
    attachmentTypeIdSTMS: 5,
    isSuccess: false,
    selectedTab: null,
    loading: false,
    categoryIdWaterTest: 9,
    waterTestDateMenu: false,
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {
    'form.preferred_dates': function (val) {
      // Prevent more than 2 dates
      if (val.length > 2) {
        this.form.preferred_dates = val.slice(0, 2);
      }
    },
  },
  created() {
    this.form = { ...this.defaultForm };
    this.init();
  },
  methods: {
    init() {
      // this.getProjects();
      this.getCategories();
      this.getExteriorFinish();
      this.getPressureTestingTypes();
      this.getSamples();
    },

    // async getProjects() {
    //   const submitModel = {
    //     filters: {},
    //   };

    //   const res = await this.$api.project.readData(submitModel);
    //   const cancelCode = 3001;
    //   if (res === cancelCode) {
    //     return;
    //   }
    //   if (!res || !res.data) {
    //     this.projects = [];
    //     return;
    //   }
    //   this.projects = res.data;
    // },

    async getCategories() {
      const res = await this.$api.stmsCategory.getList();
      this.categories = res.filter((cat) => cat.id !== this.categoryIdWaterTest);
    },

    async getExteriorFinish() {
      this.exteriorFinishes = await this.$api.stmsExteriorFinish.getList();
    },

    async getPressureTestingTypes() {
      this.pressureTestingTypes = await this.$api.stmsPressureTestingType.getList();
    },

    async getSamples() {
      this.samples = await this.$api.stmsSample.getList();
    },

    async submit() {
      const valid = await this.$refs.form.validate();
      if (!valid) {
        if (!this.form.contact_email || !this.form.contact_phone || !this.form.contact_name || !this.form.address || !this.form.floor || !this.form.unit) {
          this.$bus.$emit('showError', 'Please fill in all required fields.');
          this.loading = false;
          return;
        }
        if (this.selectedTab === 1) {
          if (!this.form.is_caulking_completed || this.form.exterior_finish_ids.length === 0 || !this.form.pressure_testing_type_id || !this.form.test_pressure || !this.form.spray_duration || !this.form.test_duration || !this.form.nozzle_type || !this.form.weather_conditions || this.form.sample_ids.length === 0 || !this.form.description || !this.form.water_test_date) {
            this.$bus.$emit('showError', 'Please fill in all required fields.');
            this.loading = false;
            return;
          }
        } else if (!this.form.category_ids || this.form.category_ids.length === 0 || !this.form.job_description) {
          this.$bus.$emit('showError', 'Please fill in all required fields.');
          this.loading = false;
          return;
        }
        return;
      }
      this.loading = true;
      if (this.selectedTab === 1) {
        this.form.category_ids = [this.categoryIdWaterTest];
      } else {
        this.form.category_ids = [this.form.category_ids];
      }
      if (this.form.preferred_dates.length > 0) {
        const preferredDatePrimary = this.form.preferred_dates[0] || null;
        const preferredDateSecondary = this.form.preferred_dates[1] || null;
        this.form.preferred_date_primary = preferredDatePrimary;
        this.form.preferred_date_secondary = preferredDateSecondary;
      }
      const res = await this.$api.stmsRequest.store(this.form);

      if (!res) {
        this.$bus.$emit('showError');
        this.loading = false;
        return;
      }

      if (this.attachments.length > 0) {
        const submitModel = {
          record_id: res,
          type_id: this.attachmentTypeIdSTMS,
        };
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.attachments.length; i++) {
          const formData = new FormData();
          formData.append('file', this.attachments[i]);
          formData.append('record_id', submitModel.record_id);
          formData.append('type_id', submitModel.type_id);
          // eslint-disable-next-line no-await-in-loop
          const resAttachment = await this.$api.attachment.store(formData);
          if (!resAttachment) {
            this.$bus.$emit('showError');
            return;
          }
        }
      }
      this.form.id = res;
      this.$bus.$emit('showSuccess');
      this.loading = false;
      this.isSuccess = true;
    },

    async getAddressData(addressData, placeData) {
      this.form.address = placeData.address;
    },

    allowedDates(date) {
      const d = new Date(date);
      const today = new Date();

      // Function to add business days (skip weekends)
      const addBusinessDays = (date, days) => {
        const result = new Date(date);
        let added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          // const day = result.getDay();
          added++;
          // if (day !== 6 && day !== 5) { // skip Sunday & Saturday
          //   added++;
          // }
        }
        return result;
      };

      // Get date that is 14 business days ahead
      const minDate = addBusinessDays(today, 14);

      // const isWeekday = d.getDay() !== 6 && d.getDay() !== 5;
      const isAfterMinDate = d >= minDate;

      // return isWeekday && isAfterMinDate;
      return isAfterMinDate;
    },

    cancel() {
      this.selectedTab = null;
      this.form = { ...this.defaultForm };
      this.attachments = [];
    },
  },
};
</script>

<style scoped>
.outer-div{
  display: flex;
  gap: 20px;
  width: 100%;

}

.inner-div{
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

}

.v-input--selection-controls.v-input
{
  padding-top: 0px;
}

</style>
